"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var angular_1 = __importDefault(require("angular"));
var StudentDrivesController = /** @class */ (function () {
    function StudentDrivesController(student, CalendarModel, DrivesFilterService) {
        var _this = this;
        this.drives = [];
        this.user = student;
        this.address = angular_1.default.fromJson(this.user.school.address);
        this.calendarItems = [];
        this.CalendarModel = CalendarModel;
        this.zones = [];
        this.noSessionsAvailable = false;
        this.filterOptions = {
            days: "all",
            times: "all"
        };
        this.applyingFilter = false;
        DrivesFilterService.clearFilterOptions();
        var initialParams = {
            'month': (0, moment_1.default)().month() + 1,
            'year': (0, moment_1.default)().year()
        };
        // get drives available in the sectors that students pickup locations are in
        CalendarModel.getStudentCalendar(initialParams).then(function (response) {
            if (response.data.drives.length === 0) {
                _this.noSessionsAvailable = true;
            }
            _this.calendarItems = response.data.drives.filter(function (drive) {
                drive.date = drive.drive_date;
                drive.startTime = (0, moment_1.default)(drive.start_time, 'HH:mm:s').format('h:mm a');
                drive.typeDisplay = drive.type.name;
                drive.type = 'Drive Session';
                if (drive.private === 'Y' && drive.observation === false) {
                    drive.typeDisplay = drive.typeDisplay + ' (Hidden)';
                }
                if (drive.private === 'Y' && drive.observation === true) {
                    drive.typeDisplay = drive.typeDisplay + ' (Observation - Hidden)';
                }
                if (drive.observation === true && drive.private === 'N') {
                    drive.typeDisplay = drive.typeDisplay + ' (Observation)';
                }
                drive.timestamp = (0, moment_1.default)(drive.drive_date + ' ' + drive.start_time).unix();
                drive.location = angular_1.default.fromJson(drive.location);
                var minutes = moment_1.default.duration(drive.session_length, 'minutes');
                var datetime = (0, moment_1.default)(drive.date + ' ' + drive.startTime);
                drive.endTime = (0, moment_1.default)(drive.start_time, 'HH:mm:s').add(minutes, 'minutes').format('h:mm a');
                drive.duration = moment_1.default.duration(drive.session_length, 'minutes').asHours();
                // @ts-ignore
                drive.duration = moment_1.default.duration(drive.duration, 'hours').format("h [hours], m [minutes]");
                drive.styling = _this.CalendarModel.getStylingForDriveCard(drive);
                drive.actionRequired = (drive.hasUngradedReportcards === true && drive.status === 'Taken' && datetime.isBefore((0, moment_1.default)()));
                return drive;
            });
        });
    }
    StudentDrivesController.prototype.applyFilter = function () {
        var _this = this;
        this.noSessionsAvailable = false;
        this.applyingFilter = true;
        var filterQuery = {
            // 'start_date': DrivesFilterService.getStartDate(),
            // 'end_date': DrivesFilterService.getEndDate(),
            // 'date' : DrivesFilterService.getDate(),
            // 'service': vm.filter.service,
            // 'location': vm.filter.location,
            // 'instructor': vm.filter.instructor,
            // 'vehicle': vm.filter.vehicle,
            'days': this.filterOptions.days, // for student calendar
            'times': this.filterOptions.times // for student calendar
        };
        this.CalendarModel.getStudentCalendar(filterQuery).then(function (response) {
            _this.applyingFilter = false;
            if (response.data.drives.length === 0) {
                _this.noSessionsAvailable = true;
            }
            _this.calendarItems = response.data.drives.map(function (drive) {
                drive.date = drive.drive_date;
                drive.startTime = (0, moment_1.default)(drive.start_time, 'HH:mm:s').format('h:mm a');
                drive.typeDisplay = drive.type.name;
                drive.type = 'Drive Session';
                if (drive.observation === true && drive.private === 'N') {
                    drive.typeDisplay = drive.typeDisplay + ' (Observation)';
                }
                drive.timestamp = (0, moment_1.default)(drive.drive_date + ' ' + drive.start_time).unix();
                drive.location = angular_1.default.fromJson(drive.location);
                var minutes = moment_1.default.duration(drive.session_length, 'minutes');
                var datetime = (0, moment_1.default)(drive.date + ' ' + drive.startTime);
                drive.endTime = (0, moment_1.default)(drive.start_time, 'HH:mm:s').add(minutes, 'minutes').format('h:mm a');
                drive.duration = moment_1.default.duration(drive.session_length, 'minutes').asHours();
                // @ts-ignore
                drive.duration = moment_1.default.duration(drive.duration, 'hours').format("h [hours], m [minutes]");
                drive.styling = _this.CalendarModel.getStylingForDriveCard(drive);
                drive.actionRequired = (drive.hasUngradedReportcards === true && drive.status === 'Taken' && datetime.isBefore((0, moment_1.default)()));
                return drive;
            });
        }).catch(function (Error) {
            _this.applyingFilter = false;
            console.error(Error);
        });
    };
    StudentDrivesController.prototype.userHasFees = function () {
        return this.user.status === 'Inactive - Fee';
    };
    StudentDrivesController.prototype.pastStartDate = function () {
        return (0, moment_1.default)(this.user.usermeta.start_date, 'YYYY-MM-DD').isBefore((0, moment_1.default)());
    };
    StudentDrivesController.prototype.studentNeedsToPurchaseSessions = function () {
        var studentHasNoHours = this.user.timepurchased === 0 || this.user.timepurchased === this.user.timescheduled;
        return this.calendarItems.length === 0 && studentHasNoHours && this.userHasFees() === false;
    };
    return StudentDrivesController;
}());
StudentDrivesController.$inject = ['student', 'CalendarModel', 'DrivesFilterService'];
exports.default = StudentDrivesController;
